// Desktop: aria-expanded on hover
document.querySelectorAll('.nav__item').forEach((item) => {
    const trigger = item.querySelector('.nav__trigger');
    if (!trigger) return;
    item.addEventListener('mouseenter', () => trigger.setAttribute('aria-expanded', 'true'));
    item.addEventListener('mouseleave', () => trigger.setAttribute('aria-expanded', 'false'));
    trigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        const expanded = trigger.getAttribute('aria-expanded') === 'true';
        trigger.setAttribute('aria-expanded', String(!expanded));
        }
    });
});

// Mobile menu: open / close
const mobileMenu = document.getElementById('mobileMenu');
const mobileOverlay = document.getElementById('mobileOverlay');
const mobileOpen = document.querySelector('.mobile-toggle');
const mobileClose = document.getElementById('mobileClose');

function openMenu() {
    mobileMenu.classList.add('is-open');
    mobileOverlay.classList.add('is-active');
    document.body.style.overflow = 'hidden';
}

function closeMenu() {
    mobileMenu.classList.remove('is-open');
    mobileOverlay.classList.remove('is-active');
    document.body.style.overflow = '';
}

mobileOpen.addEventListener('click', (e) => {
    e.preventDefault();
    console.log(12)
    openMenu();
});
mobileClose.addEventListener('click', (e) => {
    e.preventDefault();
    closeMenu();
});
mobileOverlay.addEventListener('click', closeMenu);

document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && mobileMenu.classList.contains('is-open')) closeMenu();
});

  // Mobile accordion toggles
document.querySelectorAll('.mobile-nav__trigger').forEach((trigger) => {
    trigger.addEventListener('click', (e) => {
        if(trigger.getAttribute('data-accordion') != 'self') {
            e.preventDefault();
        }
        const panel = trigger.nextElementSibling;
        if (!panel) return;
        const isOpen = panel.classList.contains('is-expanded');

        // Close all
        document.querySelectorAll('.mobile-nav__sub').forEach((p) => p.classList.remove('is-expanded'));
        document.querySelectorAll('.mobile-nav__trigger').forEach((t) => t.classList.remove('is-expanded'));

        // Toggle clicked
        if (!isOpen) {
            panel.classList.add('is-expanded');
            trigger.classList.add('is-expanded');
        }
    });
});